import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRightLong, faX } from "@fortawesome/free-solid-svg-icons";

import useConfigs from "../../hooks/useConfigs";
import useThemes from "../../hooks/useThemes";

const AlertDialog = ({
  titulo,
  contenido,
  isOpen,
  onClose,
  primaryLabel,
  secondaryLabel,
  primaryOnClick,
  secondaryOnClick,
}) => {
  const { fontSizeMultiplier } = useConfigs();
  const { backgroundSeptimo, colorSecundario, colorCuarto } = useThemes();

  return (
    <>
      {isOpen && (
        <Overlay>
          <ModalContainer
            fontsizemultiplier={fontSizeMultiplier}
            colortipografia={colorCuarto}
            colorsecundario={colorSecundario}
            background={backgroundSeptimo}
          >
            <p className="titulo">{titulo}</p>
            <p className="contenido">{contenido}</p>

            <PrimaryButtom
              onClick={primaryOnClick}
              colorsecundario={backgroundSeptimo}
              background={colorSecundario}
            >
              <FontAwesomeIcon
                icon={faArrowRightLong}
                color={colorSecundario}
                size="lg"
              />
              <p>{primaryLabel}</p>
              <FontAwesomeIcon
                icon={faArrowRightLong}
                color={backgroundSeptimo}
                size="lg"
              />
            </PrimaryButtom>

            <SecondaryButtom
              onClick={secondaryOnClick}
              colorsecundario={colorSecundario}
              background={backgroundSeptimo}
            >
              {secondaryLabel}
            </SecondaryButtom>

            <div className="cerrar" onClick={onClose}>
              <FontAwesomeIcon icon={faX} color={colorSecundario} size="2x" />
            </div>
          </ModalContainer>
        </Overlay>
      )}
    </>
  );
};

export default AlertDialog;

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  padding: 4rem;
  background-color: rgba(0, 0, 0, 0.3);
`;

const ModalContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 30vw;
  min-width: 25vw;
  min-height: 20rem;
  border-radius: 2rem;
  padding: 2rem;
  background-color: ${(props) => props.background};
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);

  @media (max-width: 1023px) {
    max-width: 90vw;
  }

  .titulo {
    font-size: ${(props) => 22 * props.fontsizemultiplier};
    font-weight: 700;
    margin: 1rem 0;
    padding: 0 2rem;
    text-align: center;
    color: ${(props) => props.colorsecundario};
  }

  .contenido {
    font-size: ${(props) => 15 * props.fontsizemultiplier};
    text-align: center;
    font-weight: 500;
    color: ${(props) => props.colortipografia};
  }

  .cerrar {
    position: absolute;
    top: 4%;
    right: 4%;
    cursor: pointer;

    &:hover {
      filter: brightness(1.2);
    }
  }
`;

const PrimaryButtom = styled.button`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 60%;
  border: none;
  margin-bottom: 1rem;
  padding: 0.8rem 2rem;
  border-radius: 2rem;
  background-color: ${(props) => props.background};

  p {
    margin: auto 0;
    font-weight: 700;
    color: ${(props) => props.colorsecundario};
  }
`;

const SecondaryButtom = styled.button`
  width: 60%;
  border: none;
  margin-bottom: 1rem;
  background-color: ${(props) => props.background};
  font-weight: 700;
  color: ${(props) => props.colorsecundario};
`;

AlertDialog.propTypes = {
  titulo: PropTypes.string,
  contenido: PropTypes.string,
  isOpen: PropTypes.bool,
  primaryLabel: PropTypes.string,
  secondaryLabel: PropTypes.string,
};

AlertDialog.defaultProps = {
  titulo: "Su mensaje se ha enviado con éxito.",
  contenido:
    "Se te informará por algún de tus medios de contacto registrado la respuesta a tu solicitud",
  isOpen: false,
  primaryLabel: "Ir al inicio",
  secondaryLabel: "Nuevo mensaje",
};
